import { useMemo, useState } from "react"

import { formatNumber } from "accounting"
import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import EmptyComponent from "../../../../../Components/Empty"
import Private from "../../../../../Components/Private"
import SelectComponent from "../../../../../Components/Select"

const { Text } = Typography

// Mobile stand-in for the "Bank breakdown" table: no room for every numeric column side by
// side, so a select picks which one shows next to the bank name - same pattern as Health's
// "Breakdown by Reason Code" and AlertsByCountryMobileTable.
const AlertsByBankMobileTable = ({ rows, searchTerm }) => {
  const { t } = useTranslation()
  const [mobileColumn, setMobileColumn] = useState("count")

  const mobileColumnOptions = useMemo(
    () => [
      { label: t("Count"), value: "count" },
      { label: t("Volume ($)"), value: "volume" },
      { label: t("Average alert value"), value: "average" },
      { label: t("Share"), value: "percentage" }
    ],
    [t]
  )

  const selectedMobileColumnLabel =
    mobileColumnOptions.find((option) => option.value === mobileColumn)?.label || t("Column")

  const renderMobileValueCell = (record) => {
    switch (mobileColumn) {
      case "count":
        return <Text strong>{formatNumber(record?.count)}</Text>
      case "volume":
        return (
          <Text strong>
            <Private>{`$${formatNumber(record?.volume, 2, ",")}`}</Private>
          </Text>
        )
      case "average":
        return (
          <Text strong>
            <Private>{`$${formatNumber(record?.average ?? 0, 2, ",")}`}</Private>
          </Text>
        )
      case "percentage":
        return <Text strong>{`${formatNumber(record?.percentage ?? 0, 1, ",", ".")}%`}</Text>
      default:
        return null
    }
  }

  return (
    <Flex vertical gap={12} className="breakdown-mobile-table">
      <SelectComponent
        size="large"
        value={mobileColumn}
        onChange={setMobileColumn}
        options={mobileColumnOptions}
        style={{ width: "100%" }}
      />

      {rows.length ? (
        <>
          <div className="breakdown-mobile-table__header">
            <Text type="secondary">{t("Bank name")}</Text>
            <Text type="secondary" className="breakdown-mobile-table__header-right">
              {selectedMobileColumnLabel}
            </Text>
          </div>

          {rows.map((record) => (
            <div
              key={record.label}
              className="breakdown-mobile-table__row"
              style={{ "--dashboard-row-progress": `${record?.percentage || 0}%` }}
            >
              <Text strong className="breakdown-mobile-table__left">
                {record.label}
              </Text>
              <div className="breakdown-mobile-table__right">{renderMobileValueCell(record)}</div>
            </div>
          ))}
        </>
      ) : searchTerm ? (
        <EmptyComponent type="search" style={{ minHeight: 450 }} />
      ) : (
        <EmptyComponent type="no_data_available" style={{ minHeight: 450 }} />
      )}
    </Flex>
  )
}

export default AlertsByBankMobileTable
